;
define("header_mini_cart.tpl", function(){});

